import { render, staticRenderFns } from "./SinMenu.vue?vue&type=template&id=243db708"
import script from "./SinMenu.vue?vue&type=script&lang=js"
export * from "./SinMenu.vue?vue&type=script&lang=js"
import style0 from "./SinMenu.vue?vue&type=style&index=0&id=243db708&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports